"use es6";

import { EmptyObservable } from './EmptyObservable';
export const empty = EmptyObservable.create;